import WaButton from "@awesome.me/webawesome-pro/dist/react/button/index.js";
import WaCard from "@awesome.me/webawesome-pro/dist/react/card/index.js";
import React from "react";

import { trackEvent } from "../analytics/plausible";

type State = {
  hasError: boolean;
  error?: Error;
};

export class ErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    trackEvent("page_error", {
      error,
      info,
    });
  }

  handleReset = () => {
    this.setState({ hasError: false, error: undefined });
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) {
      return this.props.children;
    }

    return (
      <div
        className="wa-cluster"
        style={{
          minHeight: "100vh",
          justifyContent: "center",
          alignItems: "center",
          padding: 24,
        }}
      >
        <div
          className="wa-stack wa-gap-m"
          style={{
            alignItems: "center",
            textAlign: "center",
            maxWidth: 420,
          }}
        >
          <WaCard>
            <strong slot="header">Something went wrong.</strong>
            <div className="wa-caption-s" style={{ marginTop: 4 }}>
              Please try refreshing the page.
            </div>
          </WaCard>

          <WaButton variant="brand" onClick={this.handleReset}>
            Reload page
          </WaButton>
        </div>
      </div>
    );
  }
}
